import { defaultMsrpMarkupPercentage } from './orders/order';
import { roundNumberToNearestCent } from '@ami/react/core';

export class SubLineItem {
  constructor(json) {
    this.description = json.description;
    this.price = json.price;
    this.type = json.type;
  }

  static fromServerEntity(json) {
    return Object.assign(new SubLineItem(json));
  }

  getMsrp(msrpMarkupPercentage) {
    const percentage = msrpMarkupPercentage || defaultMsrpMarkupPercentage;
    if (this.price > 0) {
      return roundNumberToNearestCent((this.price * (percentage + 100)) / 100);
    } else {
      return 0;
    }
  }
}
